<template>
  <div>
    <div class="f1" v-if="disabled">{{value}}</div>
    <el-time-select
    v-else
  v-model="value"
  :picker-options="options"
  :placeholder="placeholder"
  @change="handleChange">
</el-time-select>
  </div>
</template>

<script>
import mixinDate from './mixins/date'
export default {
  mixins: [mixinDate],
  data() {
    const {
      start,
      end,
      step,
      minDate,
      maxDate
    } = this.column
    return {
      options: {
        start,
        end,
        step,
        minTime: minDate,
        maxTime: maxDate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./date.scss";
</style>
